import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { VisibilityIcon } from '../Icons/VisibilityIcon/VisibilityIcon'
import { OffVisibilityIcon } from '../Icons/OffVisibilityIcon/OffVisibilityIcon'

import styles from './FormInput.module.scss'

interface Props {
    id: string
    label: string
    name: string
    type?: string
    placeholder: string
    value: string
    isValid: boolean
    validationMessage?: string
    isRequired?: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    readOnly?: boolean
    showTogglePassword?: boolean
    className?: string
    leadingIcon?: React.ReactNode
}

export const FormInput: FC<Props> = ({
    id,
    label,
    name,
    type = 'text',
    placeholder,
    value,
    isValid,
    validationMessage,
    isRequired,
    onChange,
    onBlur,
    readOnly,
    showTogglePassword = false,
    className,
    leadingIcon,
}) => {
    const [showPassword, setShowPassword] = useState(false)
    const showError = !isValid && validationMessage
    const isPasswordField = type === 'password'
    const iconClass = classNames(styles.Icon, styles.ActiveIcon)

    const handleToggle = () => setShowPassword(prev => !prev)

    return (
        <div className={classNames(styles.FormInput, className)}>
            <label htmlFor={id} className={classNames(styles.Label, { [styles.ErrorLabel]: showError })}>
                {showError ? validationMessage : label}
                {isRequired && ' *'}
            </label>

            <div className={styles.InputWrapper}>
                {leadingIcon && <span className={styles.LeadingIcon}>{leadingIcon}</span>}
                <input
                    id={id}
                    name={name}
                    type={isPasswordField && showTogglePassword ? (showPassword ? 'text' : 'password') : type}
                    placeholder={placeholder}
                    className={classNames(styles.Input, {
                        [styles.Error]: showError,
                        [styles.hasLeadingIcon]: !!leadingIcon,
                    })}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    readOnly={readOnly}
                />
                {isPasswordField && showTogglePassword && (
                    <button
                        type="button"
                        className={styles.ToggleButton}
                        onClick={handleToggle}
                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                        {showPassword ? (
                            <OffVisibilityIcon className={iconClass} />
                        ) : (<VisibilityIcon className={iconClass} />
                        )}
                    </button>
                )}
            </div>
        </div>
    )
}
